export default "__VITE_ASSET__kyX1FZKJ__"